import { render, staticRenderFns } from "./TableRemoveButton.vue?vue&type=template&id=c908eafc&scoped=true"
import script from "./TableRemoveButton.vue?vue&type=script&lang=js"
export * from "./TableRemoveButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c908eafc",
  null
  
)

export default component.exports